import styled from 'styled-components';

export const Container = styled.div`
  border: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  margin-top: 2rem;
  width: 100%;
`;

export const Title = styled.b`
  font-size: medium;
`;

export const Content = styled.div`
  display: flex;
  height: 100px;
`;
